export default "__VITE_ASSET__buPYRETakl2G4RmOlFtnQg__"